import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OCPP_ERROR = createActionTypes('FETCH_OCPP_ERROR');
